import api from '@/client/axiosInstance';
import { Payment, PaymentStatus } from '@/types';
import axios from 'axios';

interface CreatePayment {
  stripePaymentMethodId: string;
  stripePaymentMethodType: string;
  last4: string;
  expMonth: string;
  expYear: string;
  isPrimary: boolean;
}

const handleError = (error: unknown, message: string): never => {
  if (axios.isAxiosError(error)) {
    throw new Error(
      `${message}: ${error.response?.data?.message || error.message}`,
    );
  } else {
    throw new Error(`${message}: Unknown error occurred`);
  }
};

export const getPaymentsChartData = async (
  dataType: 'week' | 'year',
): Promise<
  {
    period: string;
    amount: number;
    payments: number;
  }[]
> => {
  try {
    const response = await api.get(`users/payments-graph`, {
      params: { period: dataType },
    });
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching payments chart data');
    return [];
  }
};

export const getPayments = async (data: {
  page: number;
  limit: number;
  status: PaymentStatus;
}): Promise<{
  total: number;
  page: number;
  limit: number;
  data: Payment[];
}> => {
  try {
    const response = await api.get(`users/payments`, {
      params: { ...data },
    });
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching payments');
    return {
      total: 0,
      page: 0,
      limit: 0,
      data: [],
    };
  }
};

export const getUserPaymentsTotal = async () => {
  try {
    const response = await api.get(`users/payments-total`);
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching payments total');
    return {
      FUTURE: 0,
      PENDING: 0,
      COMPLETED: 0,
    };
  }
};

export const createPaymentMethod = async (data: CreatePayment) => {
  try {
    const response = await api.post('users/payment-method', data);
    return response.data;
  } catch (error) {
    handleError(error, 'Error creating payment method');
  }
};

export const getUserPaymentMethods = async () => {
  try {
    const response = await api.get('users/payment-method');
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching payment methods');
  }
};

export const getUserPaymentMethodsAdmin = async (id: string) => {
  try {
    const response = await api.get(`admin/payment-methods/${id}`);
    return response.data;
  } catch (error) {
    handleError(error, 'Error fetching payment methods');
  }
};

export const deletePaymentMethod = async (id: string) => {
  // try {
  const response = await api.delete(`users/payment-method/${id}`);
  return response.data;
  // } catch (error) {
  //   handleError(error, 'Error deleting payment method');
  //   return error;
  // }
};

export const updatePrimaryPaymentMethod = async (id: string) => {
  try {
    const response = await api.patch(`users/payment-method/${id}`);
    return response.data;
  } catch (error) {
    handleError(error, 'Error updating payment method');
  }
};

export const startManualProcessing = async () => {
  try {
    const response = await api.post(`users/cron-manual-trigger`);

    return response.data;
  } catch (error) {
    handleError(error, 'Error starting manual processing');
  }
};
